import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationCard = function IllustrationCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 140"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#FFA6B6",
    d: "M32.52 113.301 29.518 11.785l70.123 6.902-1.502 112.659z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "m108.206 114.319-8.852 1.064 1.292-97.142.006-.459-.457-.045-63.945-6.294 73.244-2.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m63.887 59.667.362.54.429-.488c.75-.854 1.987-2.186 3.567-3.226 1.58-1.038 3.459-1.757 5.513-1.458 5.43.816 9.858 6.79 9.753 13.503v.008c0 3.022-.943 5.704-2.59 7.649l-.118.14v.044a1.913 1.913 0 0 0-.335.265l-.145.073-.055.027-.047.04L64.435 90.23a.92.92 0 0 1-.096.007c-.043.002-.09.002-.145.002a.133.133 0 0 1-.064-.016.072.072 0 0 1-.03-.032l-.026-.05-.036-.044L48.84 71.652a.615.615 0 0 0-.063-.12v-.051l-.126-.142c-2.307-2.609-3.665-6.048-3.665-9.365 0-6.114 4.339-10.336 9.72-9.632 2.074.303 3.985 1.546 5.589 3.036 1.598 1.485 2.846 3.174 3.593 4.289Zm-15.211 11.75Z"
  }));
};